/* Shared material tip dictionary — referenced by multiple categories.
   Business logic, not user data: lives in code, never in the database. */

export const MATERIAL_TIPS = {
  // Uppers / exteriors
  Leather: "Condition every 4-6 weeks to prevent cracking; avoid direct heat.",
  "Patent Leather": "Wipe with a soft cloth only; avoid alcohol-based cleaners that dull the shine.",
  "Saffiano Leather": "Textured coating resists scratches, but avoid solvents which can strip the finish.",
  "Caviar Leather": "Pebbled and durable — wipe with a barely damp cloth, then dry immediately.",
  Lambskin: "Extremely soft and scratch-prone; store stuffed and never overfill.",
  "Exotic (Croc/Python)": "Condition sparingly with an exotic-specific product; never use standard leather cream.",
  Mesh: "Spot clean with a soft brush and mild soap; avoid soaking, which weakens the weave.",
  Suede: "Brush with a suede brush in one direction; use a suede protectant spray before first wear.",
  Nubuck: "Similar to suede — brush gently and use a nubuck-specific protectant to resist staining.",
  Canvas: "Air dry only — heat can shrink and warp canvas fibers.",
  "Coated Canvas": "Wipe with a damp cloth; the coating protects against water but scratches with abrasion.",
  Knit: "Hand wash only with a soft brush; wringing distorts the knit structure.",
  Flyknit: "Spot clean and air dry; avoid direct sunlight, which fades the yarn dye.",
  "Gore-Tex": "Wipe clean and re-apply DWR (durable water repellent) treatment periodically.",
  Nylon: "Wipe down with a damp cloth; avoid high heat which can melt or warp the fabric.",
  Ripstop: "Spot clean and air dry; the weave resists tearing but not abrasion over time.",
  Denim: "Spot clean only — full washing fades and weakens structured panels.",
  Raffia: "Keep dry and away from humidity; natural fibers become brittle when they dry out unevenly.",
  Velvet: "Brush the pile gently in one direction; never press or steam directly.",
  Satin: "Keep away from moisture and friction — watermarks and snags are effectively permanent.",
  Vegan: "Wipe with mild soap and water; avoid conditioners meant for real leather.",

  // Midsoles
  Phylon: "Keep out of direct sunlight — compressed EVA yellows and hardens with UV exposure.",
  Air: "Inspect visible air units for punctures if cushioning feels diminished.",
  "Zoom Air": "Durable but not indestructible — avoid sharp storage surfaces.",
  React: "Wipe with mild soap; avoid alcohol-based cleaners that dry out the foam.",
  Boost: "Avoid petroleum-based cleaners — they break down the TPU pellets over time.",
  EVA: "Compresses permanently under sustained weight; avoid stacking shoes on top.",
  Lunarlon: "Foam softens with age even unworn; check periodically for compression.",
  "Fresh Foam": "Store flat — the molded shape can distort if compressed unevenly.",
  Cloudfoam: "Lightweight and soft; avoid crushing under other shoes in storage.",
  TPU: "Durable and low-maintenance; wipe clean with a damp cloth.",

  // Outsoles
  "Icy / Translucent Rubber": "Yellows faster than opaque rubber — keep out of direct sunlight.",
  "Gum Rubber": "Extremely prone to yellowing from UV and oxidation; store away from light.",
  "Continental Rubber": "High-traction compound; clean tread grooves after wet-weather wear.",
  Vibram: "Extremely durable; occasional rubber protectant keeps it from cracking.",
  "Solid Rubber": "Dry-rots over years of storage — flex soles occasionally on shelved pairs.",
  Crepe: "Never use petroleum-based cleaners — crepe rubber dissolves on contact.",
  "Leather Sole": "Condition periodically; avoid wet conditions, leather soles aren't weatherproof.",
  Cork: "Keep away from moisture — cork swells and can crack when it dries back out.",

  // Hardware
  "Gold-Tone": "Polish with a dry microfiber cloth only; chemical polish strips the plating.",
  "Silver-Tone": "Tarnishes with humidity — store with an anti-tarnish strip.",
  Palladium: "Highly tarnish-resistant; a dry cloth is all it needs.",
  Brass: "Develops a patina over time; leave it or polish gently depending on the look you want.",
  Ruthenium: "Dark finish scratches visibly — avoid stacking against other hardware.",
  Lacquered: "Never use solvents; the lacquer layer will cloud or lift.",

  // Linings
  "Leather Lining": "Wipe out crumbs and debris regularly; condition lightly once or twice a year.",
  "Suede Lining": "Vacuum gently with a brush attachment; avoid liquid cleaners entirely.",
  "Fabric Lining": "Turn out and spot clean; treat ink or makeup stains immediately.",
  "Microfiber Lining": "Wipe with a barely damp cloth; dries quickly and resists staining.",

  // Closures
  Zipper: "Run a graphite pencil along the teeth if it sticks; never force a jammed pull.",
  "Turn-Lock": "Check screws periodically — they loosen with use and can be re-tightened.",
  "Magnetic Snap": "Keep magnetic closures away from cards and devices during storage.",
  "Clasp / Kiss-Lock": "Avoid over-stuffing, which strains the frame and misaligns the clasp.",
  Snap: "Check the post and socket for wear; a loose snap will pop open under load.",
  Buckle: "Condition leather straps around buckle holes, where stress concentrates.",
  "Open Top": "No closure hardware to maintain — focus on structure and shape retention.",

  Other: "Refer to manufacturer care instructions for this material.",
};
